export default __webpack_public_path__ + "static/media/sd.ff576d85.png";